import React, { useState } from "react";
import { useVenue } from "../context/VenueContext";
import { useAuth } from "../context/AuthContext";
import { voteOnSong, removeSong } from "../services/queueService";

export default function QueueScreen({ setScreen, onNotif }) {
  const { venueId, queue, isVenueMode, playerReady, handlePlaySong } = useVenue();
  const { user } = useAuth();
  const [showPayModal, setShowPayModal] = useState(false);
  const [selectedSong, setSelectedSong] = useState(null);

  const handleVote = async (song, direction) => {
    if (!user) { onNotif("Join the venue to vote", "error"); return; }
    try {
      await voteOnSong(venueId, song.docId, user.uid, direction);
    } catch (err) {
      onNotif("Couldn't register your vote", "error");
    }
  };

  const handleRemove = async (song) => {
    try {
      await removeSong(venueId, song.docId);
      onNotif(`"${song.title}" removed`);
    } catch (err) {
      onNotif("Couldn't remove that song", "error");
    }
  };

  // The venue's host can remove anything; everyone else only their own requests
  const canRemoveSong = (song) =>
    isVenueMode || (!!user && song.addedBy?.uid === user.uid);

  return (
    <div style={{ minHeight: "100vh", background: "#0A0A0A", fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 0; }
        .queue-header { padding: 48px 40px 0; max-width: 800px; margin: 0 auto; text-align: center; }
        .queue-back { background: none; border: none; font-size: 20px; cursor: pointer; color: rgba(255,255,255,0.5); padding: 0; font-family: 'DM Sans', sans-serif; transition: color 0.2s; }
        .queue-back:hover { color: rgba(255,255,255,0.8); }
        .queue-title { font-family: 'DM Serif Display', serif; font-size: clamp(28px, 4vw, 42px); color: #ffffff; letter-spacing: -1.5px; }
        .queue-sub { font-size: 12px; color: rgba(255,255,255,0.4); margin-top: 2px; }
        .venue-badge { background: rgba(29,185,84,0.1); color: #1DB954; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 100px; border: 1px solid rgba(29,185,84,0.3); }
        .queue-item { display: flex; align-items: center; gap: 12px; padding: 14px 18px; border-radius: 20px; margin: 0 auto 10px; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); transition: all 0.2s; max-width: 720px; width: calc(100% - 80px); }
        .queue-item:hover { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.15); }
        .queue-item.top { background: rgba(29,185,84,0.08); border-color: rgba(29,185,84,0.2); }
        .queue-cover { width: 44px; height: 44px; border-radius: 10px; object-fit: cover; flex-shrink: 0; }
        .vote-group { display: flex; flex-direction: column; align-items: center; gap: 2px; flex-shrink: 0; }
        .vote-btn { width: 26px; height: 26px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.15); background: none; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 11px; color: rgba(255,255,255,0.5); transition: all 0.2s; font-family: 'DM Sans', sans-serif; }
        .vote-btn:active { transform: scale(0.93); }
        .vote-btn.up-active { background: #1DB954; border-color: #1DB954; color: #ffffff; }
        .vote-btn.down-active { background: rgba(255,107,107,0.2); border-color: rgba(255,107,107,0.4); color: #ff6b6b; }
        .vote-score { font-size: 12px; font-weight: 700; color: rgba(255,255,255,0.5); text-align: center; min-width: 22px; }
        .vote-score.pos { color: #1DB954; }
        .vote-score.neg { color: #ff6b6b; }
        .playing-indicator { display: flex; align-items: flex-end; gap: 2px; height: 14px; }
        .playing-bar { width: 3px; border-radius: 2px; animation: playing 0.8s ease-in-out infinite alternate; background: #1DB954; }
        .playing-bar:nth-child(2) { animation-delay: 0.2s; }
        .playing-bar:nth-child(3) { animation-delay: 0.4s; }
        @keyframes playing { from { height: 3px; } to { height: 12px; } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
        .modal-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.7); display: flex; align-items: flex-end; z-index: 100; backdrop-filter: blur(4px); animation: fadeIn 0.2s ease; }
        .modal-sheet { background: #141414; border-top: 1px solid rgba(255,255,255,0.08); width: 100%; border-radius: 24px 24px 0 0; padding: 24px 24px 40px; animation: slideUp 0.3s cubic-bezier(0.32, 0.72, 0, 1); }
        .modal-handle { width: 36px; height: 4px; background: rgba(255,255,255,0.15); border-radius: 2px; margin: 0 auto 20px; }
        .pay-option { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px; border-radius: 20px; border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.04); cursor: pointer; margin-bottom: 8px; transition: all 0.2s; }
        .pay-option:active { background: rgba(255,255,255,0.06); transform: scale(0.99); }
        .icon-btn { background: none; border: none; cursor: pointer; padding: 4px; flex-shrink: 0; transition: all 0.2s; font-family: 'DM Sans', sans-serif; }
        .icon-btn:active { transform: scale(0.93); }
        .play-btn { font-size: 18px; color: #1DB954; }
        .skip-btn { font-size: 15px; color: rgba(255,255,255,0.3); }
        .remove-btn { font-size: 13px; color: #ff6b6b; opacity: 0.7; }
        .empty-cta { margin-top: 20px; padding: 14px 32px; border-radius: 100px; background: #1DB954; border: none; color: #ffffff; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
        .empty-cta:active { transform: scale(0.97); }
        .modal-cancel { width: 100%; padding: 14px; border-radius: 100px; background: rgba(255,255,255,0.06); border: none; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; color: rgba(255,255,255,0.5); margin-top: 4px; transition: all 0.2s; }
      `}</style>

      <div className="queue-header">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button className="queue-back" onClick={() => setScreen("home")}>‹</button>
            <div>
              <div className="queue-title">Live Queue</div>
              <div className="queue-sub">{queue.length} songs · sorted by votes</div>
            </div>
          </div>
          {isVenueMode && <span className="venue-badge">VENUE</span>}
        </div>
      </div>

      {queue.length === 0 ? (
        <div style={{ padding: "60px 20px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🎵</div>
          <div style={{ fontSize: 15, fontWeight: 600, color: "#ffffff", marginBottom: 6, letterSpacing: -0.3 }}>Queue is empty</div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", lineHeight: 1.5 }}>Be the first to request a song</div>
          <button className="empty-cta" onClick={() => setScreen("search")}>
            + Request Song
          </button>
        </div>
      ) : (
        <div style={{ padding: "0 0 16px" }}>
          {queue.map((song, i) => {
            const mine = user ? song.voters?.[user.uid] : 0;
            const vote = mine === 1 ? "up" : mine === -1 ? "down" : null;
            const isTop = i === 0;
            return (
              <div key={song.docId} className={`queue-item ${isTop ? "top" : ""}`}>
                <div style={{ width: 22, textAlign: "center", fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.3)", flexShrink: 0 }}>
                  {`#${i + 1}`}
                </div>
                <img className="queue-cover" src={song.cover} alt="" />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#ffffff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{song.title}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 1 }}>{song.artist}</div>
                </div>
                <div className="vote-group">
                  <button className={`vote-btn ${vote === "up" ? "up-active" : ""}`} onClick={() => handleVote(song, "up")}>▲</button>
                  <span className={`vote-score ${song.votes > 0 ? "pos" : song.votes < 0 ? "neg" : ""}`}>{song.votes}</span>
                  <button className={`vote-btn ${vote === "down" ? "down-active" : ""}`} onClick={() => handleVote(song, "down")}>▼</button>
                </div>
                {isVenueMode && playerReady && (
                  <button className="icon-btn play-btn" onClick={() => handlePlaySong(song)}>▶</button>
                )}
                {i > 0 && (
                  <button className="icon-btn skip-btn" onClick={() => { setSelectedSong(song); setShowPayModal(true); }}>💸</button>
                )}
                {canRemoveSong(song) && (
                  <button className="icon-btn remove-btn" title={isVenueMode ? "Remove song" : "Remove your request"} onClick={() => handleRemove(song)}>✕</button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {showPayModal && selectedSong && (
        <div className="modal-overlay" onClick={() => setShowPayModal(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" />
            <div style={{ fontSize: 18, fontWeight: 700, color: "#ffffff", marginBottom: 4, letterSpacing: -0.5 }}>Priority Options</div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", marginBottom: 16, lineHeight: 1.5 }}>Get your song played sooner</div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", padding: 14, borderRadius: 20, marginBottom: 16 }}>
              <img src={selectedSong.cover} alt="" style={{ width: 44, height: 44, borderRadius: 10, objectFit: "cover" }} />
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#ffffff" }}>{selectedSong.title}</div>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)" }}>{selectedSong.artist}</div>
              </div>
            </div>
            {[
              { label: "Play Next", desc: "Jump to #2 in queue", price: "$2.99" },
              { label: "Play Now", desc: "Interrupt current song", price: "$4.99" },
              { label: "Skip 3 Songs", desc: "Move up 3 spots", price: "$1.49" },
            ].map(opt => (
              <div key={opt.label} className="pay-option" onClick={() => { onNotif(`${opt.label} — ${opt.price} ✓`); setShowPayModal(false); }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "#ffffff" }}>{opt.label}</div>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>{opt.desc}</div>
                </div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#1DB954" }}>{opt.price}</div>
              </div>
            ))}
            <button className="modal-cancel" onClick={() => setShowPayModal(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
